module.exports = __webpack_public_path__ + "img/instagram.096daede.svg";